import { render, staticRenderFns } from "./ComponentExternalLinks.vue?vue&type=template&id=6554d5c9"
import script from "./ComponentExternalLinks.vue?vue&type=script&lang=js"
export * from "./ComponentExternalLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports